import moment from 'moment';

export default class DateUtils {

    public static getFormatedDate(date: Date): string {
        return moment(date).format('YYYY-MM-DD');
    }

    public static getFormatedDateWithTime(date: Date): string {
        return moment(date).format('YYYY-MM-DD HH:mm');
    }

    public static convertStringToDate(value: string): Date | string {
        let dateFormat = /^\d{4}-\d{2}-\d{2}.*$/;
        if (typeof value === "string" && dateFormat.test(value)) {
            return new Date(value);
        }
        return value;
    }

    public static convertStringToLocaleDate(value: string): Date | string {
        let dateFormat = /^\d{4}-\d{2}-\d{2}.*$/;
        if (typeof value === "string" && dateFormat.test(value)) {
            let dt = moment.utc(value).local().toDate();
            return dt;
        }
        return value;

    }

}